<template>
	<div>
		<ProjectTitle :project="project" v-if="projectLoaded&&theSource === 'all'" pageType="insights" :showFeatures="['url', 'locationName']">
			<template v-slot:right>
				<div class="email-insights-switcher">
					<div>
						<span v-if="showEmailLinks">
							<span
								>Send email -
								<span @click="sendEmail('matt')">Matt</span>
								&nbsp;&nbsp;&nbsp;&nbsp;<span @click="sendEmail('amber')">Amber</span> &nbsp;&nbsp;&nbsp;&nbsp;<span
									@click="sendEmail('martin')"
									>Martin</span
								>
								&nbsp;&nbsp;&nbsp;&nbsp;<span @click="sendEmail('martin-fam')">Martin Fam</span></span
							>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
						<h4 v-if="isOwner">Email Insights</h4>

						<Switcher :sameColour="true" v-model="project[emailInsightsVar]" :style="'margin: 0;'" v-if="isOwner" />
					</div>
				</div>
			</template>
		</ProjectTitle>

		<div class="email-insights-switcher-wrap" v-if="isOwner&&projectLoaded&&theSource !== 'all'">

			<div class="email-insights-switcher">
					<div>
						<span v-if="showEmailLinks">
							<span
								>Send email -
								<span @click="sendEmail('matt')" class="email-insights-switcher-link">Matt</span>
								&nbsp;&nbsp;&nbsp;&nbsp;<span @click="sendEmail('amber')" class="email-insights-switcher-link">Amber</span> &nbsp;&nbsp;&nbsp;&nbsp;<span
									@click="sendEmail('martin')"
									class="email-insights-switcher-link"
									>Martin</span
								>
								&nbsp;&nbsp;&nbsp;&nbsp;<span @click="sendEmail('martin-fam')" class="email-insights-switcher-link">Martin Fam</span></span
							>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</div>
				</div>

			<Switcher 
				:sameColour="true" 
				v-model="project[emailInsightsVar]" 
				:style="'margin: 0;'" 
				switcherLabel2="Receive weekly email updates"
				class="switcher"
			/>

		</div>

		<section :class="{'outer-pad': theSource === 'all', 'big-scores-wrap': true}" v-if="fetchedProject">
			<div
				:class="{
					modal: true,
					'no-overlay': true,
					'big-scores': true,
					'rank-tracking': true,
					'no-default': true,
					multi: theSource === 'all',
					empty: !!empty.rankTracking,
				}"
				v-if="theSource === 'rankTracking' || theSource === 'all'"
			>
				<div class="modal-wrap">
					<div class="modal-inner">
						<h2 class="modal-title" v-if="theSource === 'all'">Rank Tracking</h2>

						<div class="modal-inner-scroll">
							<h3
								:class="{
									'big-score': true,
									zero: !totalCounts.rankTracking,
								}" 
								v-if="!empty.rankTracking"
							>
								{{ totalCounts.rankTracking }}
							</h3>

							<div class="no-results" v-if="!!empty.rankTracking">
								<div class="scores">
									<div class="score" v-html="empty.rankTracking.overview" />
									<span
										class="large-button flip-colours mini"
										@click="projectSetup(empty.rankTracking.action)"
										v-if="empty.rankTracking.button"
										v-html="empty.rankTracking.button"
									/>
								</div>
							</div>

							<div class="scores" v-if="!empty.rankTracking">
								<div class="score" v-if="project.rankCaddyScore > 0">
									Caddy Score <strong>{{ project.rankCaddyScore }}</strong>
								</div>

								<div class="score">
									Keywords Tracked <strong>{{ project.keywordCount.keywordCount }}</strong> <strong class="green">{{ project.keywordCount.goneUp }}</strong> <strong class="orange">{{ project.keywordCount.same }}</strong> <strong class="red">{{ project.keywordCount.goneDown }}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				:class="{
					modal: true,
					'no-overlay': true,
					'big-scores': true,
					'data-dive': true,
					'no-default': true,
					multi: theSource === 'all',
					empty: !!empty.dataDive,
				}"
				v-if="theSource === 'dataDive' || theSource === 'all'"
			>
				<div class="modal-wrap">
					<div class="modal-inner">
						<h2 class="modal-title" v-if="theSource === 'all'">Data Dive</h2>

						<div class="modal-inner-scroll">
							<h3
								:class="{
									'big-score': true,
									zero: totalCounts.dataDive === '0',
								}" 
								v-if="!empty.dataDive"
							>
								{{ totalCounts.dataDive }}
							</h3>

							<div class="no-results" v-if="!!empty.dataDive">
								<div class="scores">
									<div class="score" v-html="empty.dataDive.overview" />
									<span
										class="large-button flip-colours mini"
										@click="projectSetup(empty.dataDive.action)"
										v-if="empty.dataDive.button&&!!fullAccess"
										v-html="empty.dataDive.button"
									/>
								</div>
							</div>

							<div class="scores" v-if="!empty.dataDive && !!project.impressions">
								<div
									class="score"
									v-for="(s, sIndex) in [
										{
											type: 'impressions',
											label: 'Impressions',
										},
										{
											type: 'clicks',
											label: 'Clicks',
										},
									]"
									:key="s.type + '-score-' + sIndex"
								>
									{{ s.label }}
									<strong>{{ project[s.type].current }}</strong>
									<strong
										:class="{
											red: project[s.type].slug === 'down',
											green: project[s.type].slug === 'up',
										}"
										v-if="project[s.type].change > 0"
										>{{ upDown(project[s.type]) }}{{ project[s.type].change }}</strong
									>
								</div>
								<p class="days">Based on {{ days }} days of data</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section
			v-for="(opportunityPanel, opportunityPanelIndex) in opportunityPanels"
			:key="'opps-panel-' + opportunityPanelIndex"
			:class="{ 'outer-pad': theSource === 'all' }"
		>
			<div
				:class="{
					modal: true,
					'no-overlay': true,
					opportunities: true,
					'no-default': true,
					empty: empty[opportunityPanelIndex],
					[opportunityPanelIndex]: true,
				}"
				v-if="opportunityPanel.results.length > 0"
			>
				<div class="modal-wrap">
					<div class="modal-inner">
						<h2
							:class="{
								'modal-title': true,
								['days' + days]: true,
								noMargin: empty[opportunityPanelIndex],
							}"
						>
							<span class="title" v-html="opportunityPanel.title" v-if="opportunityPanels.length>1" /><br v-if="opportunityPanels.length>1" />
							<span class="description" v-html="opportunityPanel.description" v-if="opportunityPanel.description" />
							<hr />
						</h2>

						<div class="modal-inner-scroll">
							<div class="no-results" v-if="empty[opportunityPanelIndex]">
								<h3 v-html="empty[opportunityPanelIndex].title" />

								<p v-html="empty[opportunityPanelIndex].description" />

								<span
									class="large-button flip-colours mini"
									@click="projectSetup(empty[opportunityPanelIndex].action)"
									v-if="empty[opportunityPanelIndex].button"
									v-html="empty[opportunityPanelIndex].button"
								/>
							</div>

							<div class="info-boxes" v-if="!empty[opportunityPanelIndex]">
								<div
									v-for="(infoBox, infoBoxIndex) in opportunityPanel.results"
									:key="opportunityPanel.type + '-infobox-' + infoBoxIndex"
									:class="{
										'info-box': true,
										keywords: boxIs(infoBox, 'keywords'),
										'table-and-text': boxIs(infoBox, 'table-and-text'),
										[infoBox.slug]: true,
									}"
								>
									<h3 class="title" v-if="boxIs(infoBox, ['keywords', 'climbs-drops'])">
										<Icon :type="infoBox.slug" class="svg" /><span
											>{{ infoBox.name }}<span style="font-weight:normal;" v-if="!!infoBox.appendByURL"> By URL</span
											><span style="font-weight:normal;" v-if="!!infoBox.appendByKeyword"> By Keyword</span></span
										>
									</h3>

									<div class="table-arrow-wrap" v-if="boxIs(infoBox, 'keywords')">
										<div
											:class="{
												'has-headings': true,
												table: true,
												arrow: true,
												right: true,
												green: true,
												single: infoBox.results.goneDown.length === 0,
											}"
											v-if="infoBox.results.goneUp.length > 0"
										>
											<div
												:class="{
													'table-inner': true,
													singleRow: infoBox.results.goneUp.length === 1,
												}"
											>
												<span
													><span>Keyword </span
													><span v-html="opportunityPanelIndex === 'rankTracking' ? 'Current Rank ' : 'Avg Rank '"
												/></span>

												<span v-for="(k, kIndex) in infoBox.results.goneUp" :key="'k-up-' + kIndex"
													><span :title="k.keyword">{{ k.keyword }}</span>
													<span class="green"
														><strong>{{ k.position }}</strong> ⇧{{ k.positionChange }}</span
													></span
												>
											</div>
										</div>

										<div
											:class="{
												'has-headings': true,
												table: true,
												arrow: true,
												left: true,
												red: true,
												single: infoBox.results.goneUp.length === 0,
											}"
											v-if="infoBox.results.goneDown.length > 0"
										>
											<div
												:class="{
													'table-inner': true,
													singleRow: infoBox.results.goneDown.length === 1,
												}"
											>
												<span
													><span>Keyword </span
													><span v-html="opportunityPanelIndex === 'rankTracking' ? 'Current Rank ' : 'Avg Rank '"
												/></span>

												<span v-for="(k, kIndex) in infoBox.results.goneDown" :key="'k-up-' + kIndex"
													><span :title="k.keyword">{{ k.keyword }}</span>
													<span class="red"
														><strong class="orange">{{ k.position }}</strong> ⇩{{ k.positionChange }}</span
													></span
												>
											</div>
										</div>
									</div>

									<div class="content" v-if="boxIs(infoBox, 'table-and-text')">
										<div class="svg-wrap">
											<Icon :type="infoBox.slug" class="svg" />
										</div>

										<h3 class="table-and-text-title">
											<span class="new" v-if="!!infoBox.new">New <br /></span
											><span
												>{{ infoBox.name }}<span style="font-weight:normal;" v-if="!!infoBox.appendByURL"> By URL</span
												><span style="font-weight:normal;" v-if="!!infoBox.appendByKeyword"> By Keyword</span></span
											>
										</h3>

										<p>
											{{ infoBox.description
											}}<span v-if="!!infoBox.description2 && !showAllDescription(infoBox, infoBoxIndex)"
												>... <span class="more" @click="readMore(infoBox, infoBoxIndex)"><br />read more >></span></span
											><span v-if="!!infoBox.description2 && showAllDescription(infoBox, infoBoxIndex)">
												{{ infoBox.description2 }}</span
											>
										</p>

										<router-link :to="infoBox.viewAll" class="large-button flip-colours mini no-margin">View all</router-link>
									</div>

									<div
										:class="{
											table: true,
											'single-column': !!infoBox.singleColumn,
											arrow: boxIs(infoBox, 'climbs-drops'),
											right: boxIs(infoBox, 'climbs-drops'),
											red: boxIs(infoBox, 'page-drops'),
											green: boxIs(infoBox, 'page-climbs'),
											'has-headings': infoBox.showHeadings,
										}"
										v-if="boxIs(infoBox, ['table-and-text', 'climbs-drops'])"
									>
										<div class="table-inner" v-if="!!infoBox.singleColumn">
											<span v-for="(c, cIndex) in infoBox.results" :key="infoBox.slug + '-' + cIndex">{{ c.cell }}</span>
										</div>

										<div class="table-inner" v-if="!infoBox.singleColumn && !boxIs(infoBox, 'climbs-drops')">
											<span v-if="infoBox.showHeadings"
												><span v-for="(field, fieldIndex) in infoBox.fields" :key="infoBox.slug + '-th-' + fieldIndex"
													>{{ headings[field] }}
												</span></span
											>

											<span v-for="(result, resultIndex) in infoBox.results" :key="infoBox.slug + '-res-' + resultIndex"
												><span
													v-for="(field, fieldIndex) in infoBox.fields"
													:key="infoBox.slug + '-resf-' + fieldIndex"
													:title="result[field]"
													v-html="fN(result[field], fieldIndex, field)"
											/></span>
										</div>

										<div
											:class="{
												'table-inner': true,
												singleRow: infoBox.results.length === 1,
											}"
											v-if="boxIs(infoBox, 'climbs-drops')"
										>
											<span v-if="infoBox.showHeadings"
												><span v-for="(field, fieldIndex) in infoBox.fields" :key="infoBox.slug + '-th-' + fieldIndex"
													>{{ headings[field] }}
												</span></span
											>

											<span v-for="(result, resultIndex) in infoBox.results" :key="infoBox.slug + '-res-' + resultIndex"
												><span :title="fullUrl(result[infoBox.fields[0]])" v-html="fN(result[infoBox.fields[0]], 0, 'url')" />
												<span
													:class="{
														red: boxIs(infoBox, 'page-drops'),
														green: boxIs(infoBox, 'page-climbs'),
													}"
													><strong
														:class="{
															orange: boxIs(infoBox, 'page-drops'),
														}"
														>{{ result[infoBox.fields[1]] }}</strong
													>
													{{ upDown(infoBox) }}{{ result.change }}</span
												></span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<Investigate v-if="showInvestigate" :theInvestigations="investigations" @close="closeInvestigateModal" :project="theProjectId" />

		<ProjectSetup v-if="showProjectSetup" @close="closeProjectSetup" :projectInfo="project" :updateType="showProjectSetup" />

		<Keywords v-if="showKeywordModal" @close="closeKeywordModal" :project="project._id" :internal="true" />
	</div>
</template>

<script>
	import Vue from "vue";
	import { mapMutations, mapState } from "vuex";
	import ApiService from "./../services/api.service";
	import general from "./../utils/general";
	import Table from "./../components/Table.vue";
	import ActionsBar from "./../components/Display/ActionsBar.vue";
	import PageMessage from "./../components/PageMessage.vue";
	import Switcher from "./../components/Switcher.vue";
	import ProjectTitle from "./../components/Display/ProjectTitle.vue";
	import Icon from "./../components/Display/Icon.vue";
	import Investigate from "./../components/Investigate.vue";
	import ProjectSetup from "./../components/ProjectSetup.vue";
	import Keywords from "./../components/Keywords.vue";
	export default {
		name: "Insights",
		props: {
			projectId: {
				type: String,
				required: true,
			},
			source: {
				type: String,
				required: false,
				default: "all",
			},
		},
		components: {
			Table,
			ProjectTitle,
			ActionsBar,
			PageMessage,
			Switcher,
			Investigate,
			Icon,
			ProjectSetup,
			Keywords,
		},
		data() {
			return {
				showInvestigate: false,
				investigations: [],
				project: {},
				rankTracking: {},
				dataDive: {},
				fetchedProject: false,
				readMores: {},
				days: 0,
				headings: {},
				showProjectSetup: false,
				showKeywordModal: false,
				emailInsights: false,
				readOnly: true
			};
		},
		watch: {
			projectListLoaded: {
				deep: true,
				handler() {},
			},
			project: {
				deep: true,
				handler() {
					if (this.emailInsights !== this.project[this.emailInsightsVar]) {
						ApiService.post("projects/toggle-email-insights/" + this.theProjectId + '/' + this.theSourceDash )
							.then(function(info) {}.bind(this))
							.catch(
								function(err) {
									this.project[this.emailInsightsVar] = !this.project[this.emailInsightsVar];
								}.bind(this)
							);
					}

					this.emailInsights = this.project[this.emailInsightsVar];
				},
			},
		},
		computed: {
			...mapState("general", ["tableSortingInfo", "dateTimeFormat", "projectList", "projectListLoaded", "userInfo"]),

			theSource() {
				if ( this.source === 'rank-tracking' ) {
					return 'rankTracking';
				}

				if ( this.source === 'data-dive' ) {
					return 'dataDive';
				}

				return this.source;
			},

			emailInsightsVar () {

				return 'emailInsights' + general.ucFirst(this.theSource);

			},

			theSourceDash() {
				if ( this.theSource === 'rankTracking' ) {
					return 'rank-tracking';
				}

				if ( this.theSource === 'dataDive' ) {
					return 'data-dive';
				}

				return this.theSource;
			},

			fullAccess() {
				return this.fetchedProject && !!this.project.isAdmin;
			},

			showEmailLinks() {
				return window.location.host !== "app.rankcaddy.io";
			},

			totalCounts() {
				return {
					rankTracking: !!this.rankTracking ? this.formatNumber(this.rankTracking.totalCount) : '',
					dataDive: !!this.dataDive ? ( this.formatNumber(this.dataDive.totalCount) + (this.dataDive.totalCount < this.dataDive.totalCountActual ? "+" : "") ) : '',
				};
			},

			empty() {
				return {
					rankTracking: !!this.rankTracking && !!this.rankTracking.empty ? this.rankTracking.emptyInfo : false,
					dataDive: !!this.dataDive && !!this.dataDive.empty ? this.dataDive.emptyInfo : false,
				};
			},

			panels() {
				if (!this.fetchedProject) return [];

				let d = !!this.project.googleCheckedUpto ? this.project.googleCheckedUpto : this.project.lastGoogleCheck;

				d = general.timeAgo(d, "M jS 'y", "H:i", "M jS");
				let rr = [];

				if (this.theSource === 'rankTracking' || this.theSource === 'all') {
					rr.push({
						type: "rankTracking",
						title: "Opportunities from Rank Tracking",
						name: "Rank Tracking",
						description:
							!this.empty.rankTracking && "The data below will update in line with your rank tracking schedule for this project.",
						notHas: {
							subTitle: "You could be missing out on some big opportunities in RankTracking!",
							description:
								"Click the button below to add Rank Tracking to your project and get those opportunities straight to your inbox.",
						},
					});
				}
				if (this.theSource === 'dataDive' || this.theSource === 'all') {
					rr.push({
						type: "dataDive",
						title: "Opportunities from Data Dive",
						name: "Data Dive",
						description:
							!this.empty.dataDive &&
							'Updated every <span style="color:#f1492a;">' +
								this.days +
								' days</span>, last updated <span style="color:#f1492a;">' +
								general.dateFormat("M jS", this.project.lastGoogleCheck) +
								"</span>.",
						notHas: {
							subTitle: "You could be missing out on some big opportunities in Data Dive!",
							description:
								"Click the button below to add Data Dive to your project and get those opportunities straight to your inbox.",
						},
					});
				}

				if (!this.empty.dataDive && this.empty.rankTracking &&  this.theSource === 'all') {
					rr = [rr[1]];
				}
				return rr;
			},

			has() {
				return {
					rankTracking: !!this.rankTracking.has && !this.rankTracking.firstCheck && this.rankTracking.keywordCount > 0,
					dataDive: !!this.dataDive.has && !this.dataDive.firstCheck,
				};
			},

			opportunityPanels() {
				let toReturn = {};

				this.panels.forEach(
					function(panel) {
						if (!this.fetchedProject) return;

						toReturn[panel.type] = {
							results: [],
						};

						Object.keys(panel).forEach(function(key) {
							toReturn[panel.type][key] = panel[key];
						});

						if (this[panel.type].results.length > 0) {
							toReturn[panel.type] = {};

							Object.keys(panel).forEach(function(key) {
								toReturn[panel.type][key] = panel[key];
							});

							toReturn[panel.type].results = this[panel.type].results;
						}
					}.bind(this)
				);

				return toReturn;
			},
			projectLoaded() {
				return this.fetchedProject;
			},
			theProjectId() {
				return this.projectId || this.$route.params.projectId;
			},
			isAdmin() {
				return this.fetchedProject && !!this.project.isAdmin;
			},
			isOwner() {
				return this.fetchedProject && !!this.project.isOwner;
			},
		},
		methods: {
			...mapMutations("general", ["updateLoadingText", "reloadInstructionalTips"]),

			addKeywords(ev) {
				if (ev && !!ev.preventDefault) ev.preventDefault();

				if (this.isAdmin) {
					this.showKeywordModal = true;
					return;
				}

				general.$snotify(
					this,
					"error",
					"Add Keywords",
					"The project owner needs to grant you Full Access to this project to allow adding keywords"
				);
			},

			closeKeywordModal(info) {
				this.showKeywordModal = false;

				if (!!info) {
					this.loadProject();
				}

				general.modalClose();
			},

			readMore(infoBox, infoBoxIndex) {
				Vue.set(this.readMores, infoBox.slug + infoBoxIndex, true);
			},
			showAllDescription(infoBox, infoBoxIndex) {
				return !!this.readMores[infoBox.slug + infoBoxIndex];
			},

			formatNumber(n) {
				return general.formatNumber(n);
			},

			fullUrl(n) {
				return n.substring(0, 4) === ".../" ? this.project.url + n.substring(3) : n;
			},

			fN(n, index, field) {
				switch (index) {
					case 0:
						if (field === "url") {
							let url = this.fullUrl(n);

							return '<a href="' + url + '" target="_blank" style="text-decoration:none;color:inherit;">' + n + "</a>";
						}

						break;

					case 1:
						return isNaN(n) ? n : this.formatNumber(n);
				}

				return n;
			},

			upDown(infoBox) {
				return ["page-climbs", "up"].indexOf(infoBox.slug) >= 0 ? "⇧" : "⇩";
			},

			boxIs(infoBox, type) {
				if (Array.isArray(type)) {
					let ok = false;

					type.forEach(
						function(t) {
							if (this.boxIs(infoBox, t)) ok = true;
						}.bind(this)
					);

					return ok;
				}

				if (type === "keywords") type = "keywordsUpDown";

				if (type === "table-and-text") {
					return ["keywordsUpDown", "page-climbs", "page-drops"].indexOf(infoBox.slug) === -1;
				}

				switch (type) {
					case "keywordsUpDown":
					case "page-climbs":
					case "page-drops":
						return infoBox.slug === type;

					case "climbs-drops":
						return infoBox.slug === "page-climbs" || infoBox.slug === "page-drops";
				}
			},

			closeInvestigateModal() {
				general.modalClose();

				this.showInvestigate = false;
			},

			sendEmail(to) {
				this.updateLoadingText("Sending email...");

				ApiService.get("projects/insights-email/" + this.theProjectId + "/" + to + "/" + this.theSource)
					.then(
						function(info) {
							this.updateLoadingText();
						}.bind(this)
					)
					.catch(
						function(err) {
							this.project = {};
							this.updateLoadingText();
						}.bind(this)
					);
			},

			loadProject(callback) {
				this.updateLoadingText("Fetching/generating your insights, please wait a moment...");

				ApiService.get("projects/insights/" + this.theProjectId)
					.then(
						function(info) {
							this.emailInsights = !!info.data.project[this.emailInsightsVar];
							Vue.set(this, "project", info.data.project);
							Vue.set(this, "rankTracking", info.data.rankTracking);
							Vue.set(this, "dataDive", info.data.dataDive);
							Vue.set(this, "days", info.data.days);
							Vue.set(this, "headings", info.data.headings);

							this.fetchedProject = true;
							this.updateLoadingText();
							this.reloadInstructionalTips();

							if (typeof callback === "function") callback();
						}.bind(this)
					)
					.catch(
						function(err) {
							this.project = {};
							this.updateLoadingText();
						}.bind(this)
					);
			},

			closeProjectSetup(info) {
				general.modalClose();

				this.showProjectSetup = null;

				if (!!info && typeof info === "object") {
					this.loadProject();
				}
			},

			projectSetup(type) {
				if (type === "keywords") {
					this.addKeywords();
				} else {
					this.showProjectSetup = type;
				}
			},
		},
		created() {
			this.loadProject(
				function() {
					let h = window.location.hash.replace("#", "");

					switch (h) {
						case "add-rank-tracking":
							this.projectSetup("rankTracking");

							break;

						case "add-data-dive":
							this.projectSetup("dataDive");

							break;

						case "add-keywords":
							this.projectSetup("keywords");

							break;
					}
				}.bind(this)
			);
		},
	};
</script>

<style lang="less" scoped>
	@import "./../assets/css/less/_settings.less";
	@import "./../assets/css/less/_helper.less";
	@imgRoot: "./../";

	.email-insights-switcher-wrap {

		display: flex;
		justify-content: flex-end;
		margin-bottom: 10px;

	}

	.email-insights-switcher {
		display: block;
		float: right;

		> div {
			display: flex;
			padding: 0;
		}

		h4 {
			display: inline-block;
			padding-right: 10px;
		}

		&.single-switcher {

			margin-bottom: 10px;

		}

		.email-insights-switcher-link {

			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}

		}
	}

	.big-scores-wrap {
		padding-bottom: 10px;
	}

	.outer-pad {
		&.hide {
			display: none;
		}
	}

	.modal {
		.modal-wrap {
			margin-top: 30px;

			.modal-inner {
				width: 100%;

				.modal-title {
					line-height: 1.35em;

					span {
						&.description {
							font-size: 0.7em;
							font-weight: normal;
						}
					}
				}

				.modal-inner-scroll {
					.title {
						margin-bottom: 26px;
						font-size: 18px;

						.svg {
							width: 42px;
							margin-right: 15px;
						}

						.svg-wrap {
							margin-right: 15px;
							height: 42px;

							.svg {
								width: 100%;
								max-width: 42px;
								margin: 0;
							}
						}
					}

					.table-arrow-wrap {
						.table {
							margin-top: 50px;

							&:first-child {
								margin-top: 0;
							}
						}
					}

					.table {
						.table-inner {
							background-color: #f8f9fc;
							border-radius: 8px;
							padding: 10px 20px;
						}

						&.arrow {
							font-size: 60px;

							.table-inner {
								position: relative;
								margin-right: 1em;

								&:after {
									display: block;
									position: absolute;
									right: -0.7666em;
									background: url(../assets/img/arrow-green-curved.svg) no-repeat center center;
									background-size: 100% auto;
									width: 1em;
									height: 1.8333em;
									content: "";
									z-index: 2;
									top: 20px;
								}

								&.singleRow {
									&:after {
										top: 6px;
									}
								}
							}

							&.left {
								.table-inner {
									margin-right: 0;
									margin-left: 1em;

									&:after {
										right: auto;
										left: -0.7666em;
										background: url(../assets/img/arrow-red-curved.svg) no-repeat center center;
									}
								}
							}

							&.red {
								.table-inner {
									&:after {
										background: url(../assets/img/arrow-red-curved.svg) no-repeat center center;
										bottom: 20px;
										top: auto;
									}

									&.singleRow {
										&:after {
											bottom: 6px;
										}
									}
								}

								&.right {
									.table-inner {
										&:after {
											transform: scaleX(-1);
										}
									}
								}
							}
						}

						span {
							font-size: inherit;
						}

						.table-inner {
							> span {
								display: block;
								font-size: 16px;
								padding: 10px 15px;
								border-bottom: 1px solid #fff;
								text-align: inherit;

								&:last-child {
									border-bottom: none;
								}

								> span {
									display: inline-block;
								}
							}
						}

						&.single-column {
							text-align: center;
						}

						&:not(.single-column) {
							.table-inner {
								> span {
									display: flex;

									> span {
										white-space: nowrap;

										a {
											color: inherit;
											text-decoration: none;

											&:hover {
												text-decoration: underline;
											}
										}

										&:first-child {
											flex-grow: 1;
											padding-right: 20px;
										}

										&:first-child {
											overflow: hidden;
											text-overflow: ellipsis;
										}
									}
								}
							}
						}

						&.has-headings {
							.table-inner {
								> span {
									&:first-child {
										font-weight: 600;
									}
								}
							}
						}
					}

					.green {
						color: @green;
					}

					.orange {
						color: @orange;
					}

					.big-score {
						font-size: 80px;
						line-height: 1;
						text-align: center;
						margin-bottom: 24px;

						&.zero {
							color: @formDefaultColour;
						}

						&:after {
							content: "Opportunities";
							display: block;
							font-size: 0.2em;
						}
					}

					.scores {
						position: relative;
						min-height: 110px;

						.score {
							font-size: 18px;
							margin-top: 10px;
						}

						.days {
							font-size: 12px;

							font-style: italic;
						}
					}

					.info-box {
						margin-bottom: 50px;
						overflow: hidden;

						&.keywords {
							overflow: hidden;
						}

						&.table-and-text {
							.table {
								margin-top: 30px;
							}

							.content {
								.table-and-text-title {
									.new {
										color: @formDefaultColour;
									}
								}

								.svg {
									width: 40px;
									margin-bottom: 5px;
								}

								.svg-wrap {
									height: 40px;
									margin-bottom: 5px;

									.svg {
										max-width: 40px;
										margin: 0;
										height: 100%;
										width: auto;
									}
								}

								p {
									padding: 0;
									margin: 10px 0 15px;

									.more {
										color: @formDefaultColour;
										cursor: pointer;
										&:hover {
											text-decoration: underline;
										}
									}
								}
							}

							&.longtail-keywords {
								.content {
									.svg-wrap {
										.svg {
											max-width: 55px;
										}
									}
								}
							}
						}
					}
				}
			}
		}

		&.big-scores {
			.modal-wrap {
				.modal-inner {
					.modal-inner-scroll {
						padding: 20px 30px 10px;
					}
				}
			}

			&.empty {
				.modal-wrap {
					.modal-inner {
						background-repeat: no-repeat;
						background-position: right 10px bottom;
						background-size: auto 70%;
						.modal-inner-scroll {
							padding: 30px;
							.scores {
								min-height: 0;
								padding: 0;
							}
						}
					}
				}

				&.rank-tracking {
					.modal-wrap {
						.modal-inner {
							background-image: url(../assets/img/inactive-rank-tracking-grey.svg);
						}
					}
				}

				&.data-dive {
					.modal-wrap {
						.modal-inner {
							background-image: url(../assets/img/inactive-data-dive-grey.svg);
						}
					}
				}
			}
		}

		&.opportunities {
			.modal-wrap {
				.modal-inner {
					.modal-title {
						background: none;
						color: @darkContrast;
						padding: 20px 20px 0;
						margin: 0;

						hr {
							margin: 20px 0;
							border-color: @bgGrey;
						}
					}
				}
			}

			&.empty {
				.modal-wrap {
					.modal-inner {
						background-repeat: no-repeat;
						background-position: right 10px bottom;
						background-size: 30% auto;

						.modal-inner-scroll {
							.no-results {
								width: 70%;
							}
						}
					}
				}

				&.rankTracking {
					.modal-wrap {
						.modal-inner {
							background-image: url(../assets/img/inactive-rank-tracking.svg);
						}
					}
				}

				&.dataDive {
					.modal-wrap {
						.modal-inner {
							background-image: url(../assets/img/inactive-data-dive.svg);
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 540px) {
		.modal {
			&.big-scores {
				.modal-wrap {
					.modal-inner-scroll {
						display: flex;
						padding: 30px 50px 0px;

						.big-score {
							padding-right: 40px;
							font-size: 120px;
						}

						.scores {
							padding-top: 20px;

							.score {
								margin-top: 5px;
								font-size: 20px;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 768px) {
		.big-scores-wrap {
			display: flex;
			padding-bottom: 40px;
			width: 100%;
		}

		.modal {
			.modal-wrap {
				margin-top: 0;

				.modal-inner {
					.modal-inner-scroll {
						.info-box {
							&.table-and-text {
								display: flex;

								.table {
									width: 300px;
									flex-shrink: 0;
									margin-top: 0;

									&.single-column {
										width: 200px;
									}
								}

								.content {
									flex-grow: 1;
									padding-right: 30px;
									margin-top: 5px;

									.table-and-text-title {
									}
								}
							}

							&:nth-child(odd) {
								&.table-and-text {
									.content {
										text-align: right;
									}
								}
							}

							&:nth-child(even) {
								&.table-and-text {
									flex-direction: row-reverse;

									.content {
										padding-right: 0;
										padding-left: 30px;
									}
								}
							}
						}
					}
				}
			}

			&.big-scores {

				width: 48%;

				&:last-child {
					margin-left: 4%;
					&:first-child {
						margin-left: 0;
						width: 100%;
						.modal-inner {
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							padding: 0;
							.modal-title {
								display: none;
							}
						}
					}
				}

				.modal-wrap {
					.modal-inner-scroll {
						padding: 20px 30px 0px;

						.big-score {
							padding-right: 20px;
							font-size: 80px;
						}

						.scores {
							padding-top: 5px;

							.score {
								margin-top: 5px;
								font-size: 18px;
							}
						}
					}
				}
			}

			&.opportunities {
				&.empty {
					.modal-wrap {
						.modal-inner {
							background-size: auto 55%;
							min-height: 250px;
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1340px) {
		.modal {
			.modal-wrap {
				.modal-inner {
					.modal-inner-scroll {
						padding: 0 40px 10px;

						.info-box {
							.table {
								&.arrow {
									font-size: 40px;
								}

								.table-inner {
									padding: 8px 15px;

									> span {
										padding: 8px 12px;
										font-size: 14px;
									}
								}
							}

							&.table-and-text {
								.table {
									width: 50%;

									.table-inner {
										margin-top: 54px;
									}

									&.single-column {
										width: 40%;
									}
								}
							}
						}
					}
				}
			}

			&.opportunities {
				.modal-wrap {
					.modal-inner {
						.modal-title {
							margin: 0 0 50px;

							&.noMargin {
								margin: 0;
							}
						}

						.modal-inner-scroll {
							.info-boxes {
								display: flex;
								flex-wrap: wrap;
								justify-content: space-between;
							}

							.info-box {
								flex: 48%;
								flex-shrink: 0;
								flex-grow: 0;
								margin-bottom: 80px;
								position: relative;

								&.keywordsUpDown {
									flex: 0 0 100%;
								}

								&:after {
									display: block;
									content: "";
									position: absolute;
									left: 15%;
									top: -40px;
									width: 70%;
									height: 1px;
									background-color: @bgGrey;
								}

								&:nth-child(1),
								&:nth-child(2) {
									&:after {
										display: none;
									}
								}

								&:nth-child(even) {
									&:before {
										display: block;
										content: "";
										position: absolute;
										top: 15%;
										left: -2%;
										width: 1px;
										height: 70%;
										background-color: @bgGrey;
									}
								}

								&.keywords {
									&:after {
										width: 155%;
									}

									.title {
										margin-bottom: 0;
										height: 54px;
									}
								}

								&.after-keywords {
									margin-top: 51px;

									&:after {
										display: none;
									}
								}

								.table-arrow-wrap {
									display: flex;

									.table {
										margin-top: 0;
										width: 50%;
										flex-shrink: 0;
										flex-grow: 0;

										&.single {
											width: 100%;
										}
									}
								}
							}
						}
					}
				}

				&.empty {
					.modal-wrap {
						.modal-inner {
							background-size: auto 60%;
						}
					}
				}
			}

			&.big-scores {
				.modal-wrap {
					.modal-inner {
						.modal-inner-scroll {
							padding: 20px 30px 10px 60px;

							.big-score {
								padding-right: 50px;
								margin-bottom: 5px;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1400px) {
		.modal {
			&.big-scores {
				.modal-wrap {
					.modal-inner {
						.modal-inner-scroll {
							.scores {
								.score {
									margin-top: 3px;
									font-size: 20px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {
		.modal {
			.modal-wrap {
				.modal-inner {
					.modal-inner-scroll {
						.info-box {
							.table {
								.table-inner {
									> span {
										font-size: 16px;
									}
								}
							}
						}
					}
				}
			}

			&.big-scores {
				.modal-wrap {
					.modal-inner {
						.modal-inner-scroll {
							.big-score {
								padding-right: 80px;
								font-size: 100px;
							}

							.scores {
								.score {
									margin-top: 4px;
									font-size: 26px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
